var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status",class:{
    'status--active': _vm.active,
    clickable: _vm.clickable
  },style:(_vm.disabled ? _vm.disabledStyle : null),on:{"click":_vm.handleClick}},[(!_vm.loading)?_c('span',[_vm._v(_vm._s(_vm.text))]):_c('div',{staticClass:"spinnerContainer"},[_c('q-spinner-puff')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }